import "./Features.module.css";
import Header from "@/reusable_sections/Header";
import ModernRealEstateHub from "./sections/ModernRealEstateHub";
import AiDrivenSuperpowers from "./sections/AiDrivenSuperpowers";
import TheEdgeOfAgenticEfficiency from "./sections/TheEdgeOfAgenticEfficiency";
import MainSiteFooter from "@/reusable_sections/Footer";
export default function FeaturesPage() {
  return <div>
      <Header />
      <ModernRealEstateHub />
      <AiDrivenSuperpowers />
      <TheEdgeOfAgenticEfficiency />
      <MainSiteFooter />
    </div>;
}